import * as React from "react"
export const Svg_039 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={59}
    height={59}
    fill="none"
  >
    <g clipPath="url(#a)">
      <path
        fill="url(#b)"
        d="M48.811 35.737c0-1.36-.458-2.702-1.29-3.778l-.25-.321a24.252 24.252 0 0 1-2.312-3.612 16.202 16.202 0 0 1-7.753 9.571v4.315h5.43a6.181 6.181 0 0 0 6.175-6.175Z"
      />
      <path
        fill="url(#c)"
        d="M14.041 28.026a24.234 24.234 0 0 1-2.313 3.612l-.248.321a6.205 6.205 0 0 0-1.291 3.779 6.181 6.181 0 0 0 6.174 6.174h5.43v-4.314a16.202 16.202 0 0 1-7.752-9.572Z"
      />
      <path
        fill="url(#d)"
        d="M35.31 53.719V59h17.573v-4.55c0-5.007-4.074-9.081-9.081-9.081h-.944v8.35H35.31Z"
      />
      <path fill="url(#e)" d="m26.137 50.262-3.503-4.893h-3.035v4.893h6.538Z" />
      <path
        fill="url(#f)"
        d="M16.142 53.719v-8.35h-.944c-5.007 0-9.081 4.074-9.081 9.082V59h17.576v-5.282h-7.551Z"
      />
      <path fill="url(#g)" d="M27.15 53.719h4.703V59H27.15V53.72Z" />
      <path
        fill="url(#h)"
        d="M39.401 50.262v-4.893h-3.035l-3.503 4.893h6.538Z"
      />
      <path
        fill="url(#i)"
        d="M25.25 38.993v4.093l4.25 5.935 4.25-5.935v-4.093c-1.355.37-2.78.568-4.25.568-1.47 0-2.895-.198-4.25-.568Z"
      />
      <path
        fill="url(#j)"
        d="m41.785 7.117.328-.207C41.658 3.024 38.345 0 34.34 0h-9.68c-4.316 0-7.827 3.511-7.827 7.827v3.888h9.092a29.61 29.61 0 0 0 15.86-4.598Z"
      />
      <path
        fill="url(#k)"
        d="M25.925 15.172h-9.092v8.265c0 6.985 5.683 12.667 12.667 12.667s12.667-5.682 12.667-12.667V10.915a33.057 33.057 0 0 1-16.242 4.257Z"
      />
    </g>
    <defs>
      <linearGradient
        id="b"
        x1={39.89}
        x2={46.941}
        y1={30.109}
        y2={39.646}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={12.873}
        x2={19.923}
        y1={30.109}
        y2={39.646}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={39.374}
        x2={45.017}
        y1={47.414}
        y2={59.188}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="e"
        x1={21.111}
        x2={23.09}
        y1={46.103}
        y2={50.385}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="f"
        x1={10.181}
        x2={15.824}
        y1={47.414}
        y2={59.189}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="g"
        x1={28.238}
        x2={30.866}
        y1={54.511}
        y2={58.297}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="h"
        x1={34.375}
        x2={36.355}
        y1={46.103}
        y2={50.385}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="i"
        x1={27.216}
        x2={32.287}
        y1={40.497}
        y2={47.452}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="j"
        x1={22.679}
        x2={25.972}
        y1={1.757}
        y2={13.259}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="k"
        x1={22.692}
        x2={34.625}
        y1={14.694}
        y2={34.119}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h59v59H0z" />
      </clipPath>
    </defs>
  </svg>
)